export default "__VITE_ASSET__DuZ7uC5F__"